module.exports = __webpack_public_path__ + "img/success-academy-biznes.5362360d.png";